import script from "./Template1.vue?vue&type=script&setup=true&lang=js"
export * from "./Template1.vue?vue&type=script&setup=true&lang=js"

import "./Template1.vue?vue&type=style&index=0&id=2a3e7ed5&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a3e7ed5"]])

export default __exports__